import VideoBackgroundTab from 'features/room/settings/tabs/VideoBackgroundTab/VideoBackgroundTab';

export default VideoBackgroundTab;
